import React from 'react';

export const PersonContact = () => {
  return (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 5.25C5.86719 5.25 7 4.13672 7 2.75C7 1.38281 5.86719 0.25 4.5 0.25C3.11328 0.25 2 1.38281 2 2.75C2 4.13672 3.11328 5.25 4.5 5.25ZM5.47656 6.1875H3.50391C1.62891 6.1875 0.125 7.71094 0.125 9.58594C0.125 9.95703 0.417969 10.25 0.789062 10.25H8.19141C8.5625 10.25 8.875 9.95703 8.875 9.58594C8.875 7.71094 7.35156 6.1875 5.47656 6.1875Z"
        fill="#FFBF17"
      />
    </svg>
  );
};
